module.exports = __webpack_public_path__ + "media/123.af90f0dd.mp3";